<template>
  <div id="app">
    <router-view/>
    <!--    通用底部-->
    <Footer :footer="content.footer" bg-color="#A91728" sub-bg-color="#980028"></Footer>
  </div>
</template>

<script>
import Footer from './components/Footer'
import {pageConfig} from './api/common'
export default {
  name: 'App',
  components: { Footer},
  data() {
    return {
      // 配置数据
      content: {
        footer: {
          about: '',
          sitemap: '',
          statement: '',
          worktime: '',
          tips: '',
          public: {
            path: ''
          },
          miniprog: {
            path: ''
          },
          owner: '',
          record: '',
          logo1: {
            path: ''
          },
          logo2: {
            path: ''
          }
        },
        logo: {
          path: '',
        },
        search_keys: [],
        site_name: '',
        site_name_en: '',
      },
    }
  },
  mounted() {
    // 请求配置数据 - 根据last_time判断是否更新 lovalstorage缓存
   this.fetchConfig()
  },
  methods: {
    fetchConfig() {
      // 公共法律服务
      return pageConfig('get', {type: 'common'}).then(res => {
        this.content = res.data.content
      })
    },
  }
}
</script>

<style>
#app {}
.unselect{
  user-select: none;
}
.flex{
  display: flex;
}
.flex-column{
  flex-direction: column;
}
.flex-between{
  display: flex;
  justify-content: space-between;
}
.flex-around{
  display: flex;
  justify-content: space-around;
}
.flex-evenly{
  display: flex;
  justify-content: space-evenly;
}
.flex-right{
  justify-content: right;
}
.flex-center{
  justify-content: center;
}
.flex-wrap{
  flex-wrap: wrap;
}
.algin-item-center{
  align-items: center;
}
.algin-item-end{
  align-items: end;
}
.hand{
  cursor: pointer;
}
.cursor-hand{
  cursor: pointer;
}
/*swiper分页样式*/
.my-swiper-pagination{
  width: 1vw;
  height: 1vw;
  margin: 0 0.5vw;
  display: inline-block;
  border-radius: 100%;
  background: #D9D9D9;
}
.my-swiper-pagination-active{
  opacity: 1;
  background: #A91728;
}

.main-width-625{
  width: 1200px;
  //width: 62.5vw;
  margin: 0 auto;
}
.flex-space-between{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/*通用字体类型*/
.font-bold{
  font-weight: bold;
}
.font-bolder{
  font-weight: bolder;
}
.font-heiti {
  font-family: '黑体';
}
.font-yahei{
  font-family: 'Microsoft YaHei', 'SimSun';
}
.font-songti{
  font-family: '宋体';
}
/*通用字体样式*/
.font-64{
  font-size: 64px;
}
.font-56{
  font-size: 56px;
}
.font-42{
  font-size: 42px;
}
.font-36{
  font-size: 36px;
}
.font-32{
  font-size: 32px;
}
.font-30{
  font-size: 30px;
}
.font-28{
  font-size: 28px;
}
.font-26{
  font-size: 26px;
}
.font-24{
  font-size: 24px;
}
.font-22{
  font-size: 22px;
}
.font-20{
  font-size: 20px;
}
.font-18{
  font-size: 18px;
}
.font-16{
  font-size: 16px;
}
.font-14{
  font-size: 14px;
}
.font-12{
  font-size: 12px;
}
.font-9{
  font-size: 9px;
}
.cursor-pointer{
  cursor: pointer;
}
.color-gold{
  color: #D0B479!important;
}
.color-red{
  color: #A91728!important;
}
/*elment-ui样式自适应*/
.el-message-box{
  width: 21.875vw!important;
}
.el-message-box__header{
  padding: 0.26vw 0.78vw !important;
}
.el-message-box__content{
  font-size: 0.8vw!important;
  padding: 0.78vw 0.78vw 0.52vw!important;
}
.el-message-box__btns{
  padding: 0.26vw 0.78vw!important;
}
.el-button--small{
  padding: 0.468vw 0.78vw!important;
  font-size: 0.625vw!important;
  border-radius: 0.208vw!important;
}
.el-message-box__headerbtn{
  font-size: 0.8vw!important;
}
.el-button--primary{
  background-color: #A91728!important;
  border-color: #A91728!important;
}
/*消息提示*/
.el-notification{
  width: 17.1875vw!important;
  padding: 0.7291vw 1.354vw 0.7291vw 0.677vw!important;
  align-items: center;
}
.el-notification__content{
  font-size: 0.8vw!important;
}
.el-notification__icon{
  height: 100% !important;
  width: 0.8vw!important;
  /*height: 0.8vw!important;*/
  font-size: 0.8vw!important;
  /*margin-top: 0.8vw!important;*/
}
.el-notification__closeBtn{
  right: 0.3vw!important;
  top: 0;
}
.text-overflow-line{
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.line-1{
  -webkit-line-clamp: 1;
}
.line-2{
  -webkit-line-clamp: 2;
}
.line-3{
  -webkit-line-clamp: 3;
}
.line-4{
  -webkit-line-clamp: 4;
}
.flex-align-center{
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue